module.exports = {
  Question: function(body, rawBody, choices, usesMarkdown){
    this.body = body
    this.rawBody = rawBody
    this.choices = choices
    this.cardComponent = "question"
    this.usesMarkdown = usesMarkdown
  },
  Answer: function(body, rawBody, answerValue, usesMarkdown){
    this.body = body
    this.rawBody = rawBody
    this.answerValue = answerValue
    this.cardComponent = "answer"
    this.usesMarkdown = usesMarkdown
  },
  Meta: function(meta) {
    this.cardId = meta.cardId
    this.readCount = meta.readCount
    this.correctCount = meta.correctCount
    this.lastReadOn = meta.lastReadOn
    this.createdOn = meta.createdOn
    this.cardType = meta.cardType
    this.cardComponent = "meta"
  },
  BaseCard: function (){
    this.question = null
    this.answer = null
    this.meta = null
  },
  generateCards: function(allCards) {
    var cards = {}
    for (var c of allCards){
      var card = cards[c.cardId]
      if (!card) {
        card = new this.BaseCard()
        cards[c.cardId] = card
      }
      if (c.cardComponent == "question"){
        card.question = new this.Question(c.body, c.rawBody, null, c.usesMarkdown)
      }
      if (c.cardComponent == "answer"){
        card.answer = new this.Answer(c.body, c.rawBody, null, c.usesMarkdown)
      }
      if (c.cardComponent == "meta") {
        card.meta = new this.Meta(c)
      }

    }
    return Object.values(cards).sort((a, b) => {
      if (a.meta.createdOn > b.meta.createdOn) return 1
      if (a.meta.createdOn < b.meta.createdOn) return -1
      return 0
    })
  }

}
